/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_XY_LIVE", "566")
  

// 接口文档

  
    
export interface IAPI77102ResDataItemAppPropertyListItemOptionListItem {
  
  /** 选项名称 */
  key?: string;
  
  /** 选项值 */
  value?: string;
  
};
    
  
    
export interface IAPI77102ResDataItemAppPropertyListItem {
  
  /** 属性编码 */
  propertyCode?: string;
  
  /** 属性名称 */
  propertyName?: string;
  
  /** 属性类型 */
  propertyType?: string;
  
  /** 属性key */
  propertyKey?: string;
  
  /** 属性值 */
  propertyValue?: string;
  
  /** 选中值 */
  selectValue?: string;
  
  /** 选项范围 ,OptionResp */
  optionList?: IAPI77102ResDataItemAppPropertyListItemOptionListItem[];
  
};
    
  
    
export interface IAPI77102ResDataItem {
  
  /** 应用编码 */
  appCode?: string;
  
  /** 应用名称 */
  appName?: string;
  
  /** 应用描述 */
  appDesc?: string;
  
  /** 是否多轮 */
  multiFlag?: number;
  
  /** 创建时间 */
  createdAt?: string;
  
  /** 应用属性列表 ,AppPropertyResp */
  appPropertyList?: IAPI77102ResDataItemAppPropertyListItem[];
  
};
    
  



export interface API77102Req {
  
  /** 应用名称 */
  appName?: string;
    
  /**  */
  pageSize?: string;
    
  /**  */
  pageIndex?: string;
    
  /**  */
  rowId?: string;
    
  /**  */
  jumpType?: string;
    
  /**  */
  searchCount?: string;
    
  /**  */
  orderObjects?: string;
    
};



export type API77102Res = IAPI77102ResDataItem[];


// 接口函数 77102 查询已发布实例列表

export interface IUseGetAPI77102Return {
  /** 查询已发布实例列表: 接口请求状态 */
  isAPI77102Loading: boolean;
  /** 查询已发布实例列表: 接口请求返回数据 */
  dataAPI77102: API77102Res;
  /**  查询已发布实例列表: 接口数据请求方法 */
  fetchAPI77102Data: (inputs: API77102Req, config?: YWRequestConfig) => Promise<API77102Res>;
  /** 查询已发布实例列表: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI77102 = ():IUseGetAPI77102Return => {
  let isMount = true;
  const [isAPI77102Loading, setIsAPI77102Loading] = useState(false);
  const [dataAPI77102, setDataAPI77102] = useState<API77102Res>({} as API77102Res);
  const requestUrl = `${basePath}/yoaichat-admin/app/release/list`;

  const fetchAPI77102Data = async (inputs: API77102Req, config?: YWRequestConfig): Promise<API77102Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API77102Req>) || {}) as API77102Req;
    
  
    if ( isMount ) {
      setIsAPI77102Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API77102Res>(`${basePath}/yoaichat-admin/app/release/list?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI77102(res || {} as API77102Res);
        setIsAPI77102Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI77102Loading(false);
      }
      return false as unknown as API77102Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI77102Loading,
    dataAPI77102,
    fetchAPI77102Data,
    requestUrl,
  }
}

